<template>
  <div id="app">
    <router-view></router-view>
    <vue-cookies-consent>
      <template #title>Ta strona używa plików cookie</template>
      <template #description>
        <p>W celu świadczenia usług na najwyższym poziomie wykorzystujemy pliki cookies oraz podobne technologie w celach statystycznych. Korzystanie z naszej witryny oznacza, że będą one zamieszczane i przechowywane w Państwa urządzeniu. W każdym momencie można dokonać zmiany ustawień Państwa przeglądarki. Więcej informacji znajdą Państwo w naszej <a style="color:#e61919" href="https://elbologistyka.pl/polityka-prywatnosci">polityce prywatności</a>.</p>
      </template>
      <template #button>Akceptuję</template>
    </vue-cookies-consent>
  </div>
</template>

<script>
import VueCookiesConsent from '@norvikit/vue-cookies-consent'

export default {
  name: 'App',
  components: {
    VueCookiesConsent
  }
}
</script>
